import clsx from 'clsx'

import { ReactComponent as ApprovalPendingIcon } from 'assets/images/status/approval-pending.svg'
import { ReactComponent as ApprovedIcon } from 'assets/images/status/approved.svg'
import { ReactComponent as InProgressIcon } from 'assets/images/status/in-progress.svg'
import { ReactComponent as NewIcon } from 'assets/images/status/new.svg'
import { ReactComponent as RejectedIcon } from 'assets/images/status/rejected.svg'
import { ReactComponent as OnHoldIcon } from 'assets/images/status/on-hold.svg'
import { ReactComponent as ScrappedIcon } from 'assets/images/status/scrapped.svg'

import styles from './StagePill.module.css'

interface StagePillProps {
  stage: AssignmentStage
}

const StagePill = ({ stage }: StagePillProps): JSX.Element => {
  switch (stage) {
    case 'approved': {
      return (
        <div className={clsx(styles.pill, styles.approved)}>
          <ApprovedIcon />
          <span className={styles.text}>Approved</span>
        </div>
      )
    }

    case 'new': {
      return (
        <div className={clsx(styles.pill, styles.new)}>
          <NewIcon />
          <span className={styles.text}>New</span>
        </div>
      )
    }

    case 'in_progress': {
      return (
        <div className={clsx(styles.pill, styles.inProgress)}>
          <InProgressIcon />
          <span className={styles.text}>In Progress</span>
        </div>
      )
    }

    case 'rejected': {
      return (
        <div className={clsx(styles.pill, styles.rejected)}>
          <RejectedIcon />
          <span className={styles.text}>Rejected</span>
        </div>
      )
    }

    case 'hold': {
      return (
        <div className={clsx(styles.pill, styles.hold)}>
          <OnHoldIcon />
          <span className={styles.text}>On Hold</span>
        </div>
      )
    }

    case 'scrapped': {
      return (
        <div className={clsx(styles.pill, styles.scrapped)}>
          <ScrappedIcon />
          <span className={styles.text}>Scrapped</span>
        </div>
      )
    }

    case 'finished': {
      return (
        <div className={clsx(styles.pill, styles.approvalPending)}>
          <ApprovalPendingIcon />
          <span className={styles.text}>Approval Pending</span>
        </div>
      )
    }

    case 'rework': {
      return (
        <div className={clsx(styles.pill, styles.inProgress)}>
          <InProgressIcon />
          <span className={styles.text}>In Progress</span>
        </div>
      )
    }

    default: {
      throw new Error(
        `ArgumentError: Expected 'stage' should be one of [approved, new, in_progress, rejected, hold, scrapped, finished] but received ${stage}.`
      )
    }
  }
}

export default StagePill
